if (!customElements.get('shop-by-size')) {
  class ShopBySize extends HTMLElement {
    constructor() {
      super();
      this.handlePopState = this.handlePopState.bind(this);
      this.syncActiveState = this.syncActiveState.bind(this);
      this.boundClickHandlers = new Map();
      this._filterAppliedUnsub = null;
      this._filterClearedUnsub = null;
      this._sortChangedUnsub = null;
    }

    connectedCallback() {
      this.paramName = this.dataset.filterParam;
      this.pills = [...this.querySelectorAll('.shop-by-size__pill')];

      this.pills.forEach((pill) => {
        const handler = (event) => this.handleButtonClick(event, pill);
        this.boundClickHandlers.set(pill, handler);
        pill.addEventListener('click', handler);
      });

      window.addEventListener('popstate', this.handlePopState);

      if (window.theme?.pubsub) {
        const events = theme.pubsub.events;
        this._filterAppliedUnsub = theme.pubsub.subscribe(events.FILTER_APPLIED, this.syncActiveState);
        this._filterClearedUnsub = theme.pubsub.subscribe(events.FILTER_CLEARED, this.syncActiveState);
        this._sortChangedUnsub = theme.pubsub.subscribe(events.SORT_CHANGED, this.syncActiveState);
      }
    }

    disconnectedCallback() {
      this.pills?.forEach((pill) => {
        const handler = this.boundClickHandlers.get(pill);
        if (handler) pill.removeEventListener('click', handler);
      });
      this.boundClickHandlers.clear();

      window.removeEventListener('popstate', this.handlePopState);

      this._filterAppliedUnsub?.();
      this._filterClearedUnsub?.();
      this._sortChangedUnsub?.();
    }

    handlePopState() {
      this.syncActiveState();
    }

    async handleButtonClick(event, pill) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

      const filters = document.querySelector('collection-filters');
      if (!filters || typeof filters.fetchAndUpdatePage !== 'function') return;

      event.preventDefault();

      const params = new URLSearchParams(window.location.search);
      const size = pill.dataset.sizeValue ?? '';
      const availability = pill.dataset.availability === 'true';

      if (size === '') {
        params.delete(this.paramName);
        if (!availability) params.delete('filter.v.availability');
      } else {
        const current = params.getAll(this.paramName);
        params.delete(this.paramName);

        if (current.includes(size)) {
          current.filter((value) => value !== size).forEach((value) => params.append(this.paramName, value));
        } else {
          current.forEach((value) => params.append(this.paramName, value));
          params.append(this.paramName, size);
        }

        if (availability) {
          params.set('filter.v.availability', '1');
        }

        const remaining = params.getAll(this.paramName);
        if (remaining.length === 0 && !availability) {
          params.delete('filter.v.availability');
        }
      }

      const url = new URL(window.location.pathname, window.location.origin);
      url.search = params.toString();

      await filters.fetchAndUpdatePage(url.toString());
      this.syncActiveState();
    }

    syncActiveState() {
      const active = new URLSearchParams(window.location.search).getAll(this.paramName);

      this.pills?.forEach((pill) => {
        const sizeValue = pill.dataset.sizeValue ?? '';
        const isActive = sizeValue === '' ? active.length === 0 : active.includes(sizeValue);

        pill.classList.toggle('is-active', isActive);

        if (isActive) {
          pill.setAttribute('aria-current', 'true');
        } else {
          pill.removeAttribute('aria-current');
        }
      });
    }
  }

  customElements.define('shop-by-size', ShopBySize);
}
